import BRANDING from './brandingConst';
import { MOBILE_BRANDING } from './mobileBrandingConst';

const globalPrefix = '--global-';
const btnPrimaryPrefix = '--fluid-btn-primary-';
const mastheadPrefix = '--masthead-';
const mainNavPrefix = '--main-nav-';
const utilNavPrefix = '--utility-nav-';
const featuredNavPrefix = '--featured-nav-';
const widgetPrefix = '--widget-';
const bodyPrefix = `${globalPrefix}body-`;
const fluidGlobalPrefix = '--fluid-global-';
const expPreviewPrefix = '--exp-preview-';
const mobileGlobalPrefix = `${expPreviewPrefix}mobile-global-`;

export default {
    // ========================================================
    //  Web - Typography
    // ========================================================
    [BRANDING.GLOBAL_BODY_FONT_FAMILY]: `${globalPrefix}body-font-family`,
    [BRANDING.GLOBAL_HEADING_FONT_FAMILY]: `${globalPrefix}heading-font-family`,
    // ========================================================
    //  Web - Colors
    // ========================================================
    [BRANDING.GLOBAL_FONT_COLOR]: `${globalPrefix}font-color`,
    [BRANDING.GLOBAL_LINK_COLOR]: `${globalPrefix}link-default-color`,
    [BRANDING.GLOBAL_ERROR_COLOR]: `${globalPrefix}error-color`,
    [BRANDING.GLOBAL_DESTRUCTIVE_COLOR]: `${globalPrefix}destructive-color`,
    [BRANDING.GLOBAL_INFO_COLOR]: `${globalPrefix}info-color`,
    [BRANDING.GLOBAL_PRIMARY_COLOR]: `${globalPrefix}primary-color`,
    [BRANDING.GLOBAL_SECONDARY_COLOR]: `${globalPrefix}secondary-color`,
    [BRANDING.GLOBAL_TERTIARY_COLOR]: `${globalPrefix}tertiary-color`,
    [BRANDING.GLOBAL_SUCCESS_COLOR]: `${globalPrefix}success-color`,
    [BRANDING.GLOBAL_WARNING_COLOR]: `${globalPrefix}warning-color`,
    // ========================================================
    //  Web - Button - Shared
    // ========================================================
    [BRANDING.GLOBAL_BTN_BORDER_RADIUS]: `${fluidGlobalPrefix}btn-border-radius`,
    [BRANDING.GLOBAL_BTN_BORDER_WIDTH]: `${fluidGlobalPrefix}btn-border-width`,
    // ========================================================
    //  Web - Primary Button
    // ========================================================
    [BRANDING.GLOBAL_PRIMARY_BTN_TEXT_COLOR]: `${btnPrimaryPrefix}text-color`,
    [BRANDING.GLOBAL_PRIMARY_BTN_BG_COLOR_START]: `${btnPrimaryPrefix}bg-color-start`,
    [BRANDING.GLOBAL_PRIMARY_BTN_HOVER_BG_COLOR_START]: `${btnPrimaryPrefix}hover-bg-color-start`,
    [BRANDING.GLOBAL_PRIMARY_BTN_BG_COLOR_END]: `${btnPrimaryPrefix}bg-color-end`,
    [BRANDING.GLOBAL_PRIMARY_BTN_HOVER_BG_COLOR_END]: `${btnPrimaryPrefix}hover-bg-color-end`,
    [BRANDING.GLOBAL_PRIMARY_BTN_BG_COLOR]: `${btnPrimaryPrefix}bg-color`,
    [BRANDING.GLOBAL_PRIMARY_BTN_HOVER_BG_COLOR]: `${btnPrimaryPrefix}hover-bg-color`,
    [BRANDING.GLOBAL_PRIMARY_BTN_BORDER_COLOR]: `${btnPrimaryPrefix}border-color`,
    // ========================================================
    //  Web - Masthead
    // ========================================================
    [BRANDING.MASTHEAD_BG]: `${mastheadPrefix}background`,
    [BRANDING.MASTHEAD_BG_COLOR_START]: `${mastheadPrefix}bg-color-start`,
    [BRANDING.MASTHEAD_BG_IMG]: `${mastheadPrefix}bg-image`,
    [BRANDING.MASTHEAD_BG_IMG_POSITION]: `${mastheadPrefix}bg-position`,
    [BRANDING.MASTHEAD_BG_IMG_REPEAT]: `${mastheadPrefix}bg-repeat`,
    [BRANDING.MASTHEAD_BG_IMG_SIZE]: `${mastheadPrefix}bg-size`,
    [BRANDING.MASTHEAD_TEXT_COLOR]: `${mastheadPrefix}text-color`,
    // ========================================================
    //  Web - Main Navigation
    // ========================================================
    [BRANDING.MAIN_NAV_BG_COLOR]: `${mainNavPrefix}bg-color`,
    [BRANDING.MAIN_NAV_HOVER_BG_COLOR]: `${mainNavPrefix}hover-bg-color`,
    [BRANDING.MAIN_NAV_TEXT_COLOR]: `${mainNavPrefix}text-color`,
    [BRANDING.MAIN_NAV_BORDER_COLOR]: `${mainNavPrefix}border-color`,
    // ========================================================
    //  Web - Utility Navigation
    // ========================================================
    [BRANDING.UTILITY_NAV_BG_COLOR]: `${utilNavPrefix}bg-color`,
    [BRANDING.UTILITY_NAV_LINK_COLOR]: `${utilNavPrefix}link-color`,
    // ========================================================
    //  Web - Featured Navigation
    // ========================================================
    [BRANDING.FEATURED_NAV_LINK_COLOR]: `${featuredNavPrefix}link-color`,
    [BRANDING.FEATURED_NAV_FLAG_TEXT_COLOR]: `${featuredNavPrefix}flag-text-color`,
    [BRANDING.FEATURED_NAV_FLAG_BG_COLOR]: `${featuredNavPrefix}flag-bg-color`,
    // ========================================================
    // Web - Body
    // ========================================================
    [BRANDING.BODY_BG_COLOR_START]: `${bodyPrefix}bg-color-start`,
    [BRANDING.BODY_BG_COLOR_END]: `${bodyPrefix}bg-color-end`,
    [BRANDING.BODY_BG_IMG]: `${bodyPrefix}bg-image`,
    [BRANDING.BODY_BG]: `${bodyPrefix}bg`,
    [BRANDING.BODY_BG_IMG_POSITION]: `${bodyPrefix}bg-position`,
    [BRANDING.BODY_BG_IMG_REPEAT]: `${bodyPrefix}bg-repeat`,
    [BRANDING.BODY_BG_IMG_SIZE]: `${bodyPrefix}bg-size`,
    [BRANDING.BODY_TEXT_COLOR]: `${bodyPrefix}text-color`,
    // ========================================================
    //  Web - Widgets
    // ========================================================
    [BRANDING.WIDGETS_HEADER_BG_COLOR]: `${widgetPrefix}header-bg-color`,
    [BRANDING.WIDGETS_HEADER_TEXT_COLOR]: `${widgetPrefix}header-text-color`,
    [BRANDING.WIDGETS_BORDER_RADIUS]: `${widgetPrefix}border-radius`,
    [BRANDING.WIDGETS_BORDER_COLOR]: `${widgetPrefix}border-color`,
    [BRANDING.WIDGETS_BORDER_WIDTH]: `${widgetPrefix}border-width`,
    [BRANDING.WIDGETS_DROP_SHADOW]: `${widgetPrefix}box-shadow`,
    [BRANDING.WIDGETS_BG_OPACITY]: `${widgetPrefix}bg-opacity`,
    // ========================================================
    //  Mobile - Colors
    // ========================================================
    [MOBILE_BRANDING.MOBILE_GLOBAL_PRIMARY_BG_COLOR]: `${mobileGlobalPrefix}primary-bg-color`,
    [MOBILE_BRANDING.MOBILE_GLOBAL_BTN_BG_COLOR]: `${mobileGlobalPrefix}btn-bg-color`,
    [MOBILE_BRANDING.MOBILE_GLOBAL_PRIMARY_TEXT_COLOR]: `${mobileGlobalPrefix}primary-text-color`,
};
